export default "__VITE_ASSET__3104920f__"